import { useQuery } from 'hooks/useCustomQuery';
import getSpecialNumber from 'API/SpecialNumbers/getSpecialNumber';

const useGetSpecialNumber = (specialNumberId, enabled = true) => {
    return useQuery({
        queryKey: ['SpecialNumber', specialNumberId],
        queryFn: async () => {
            const response = await getSpecialNumber(specialNumberId);
            return response.data;
        },
        enabled: enabled && !!specialNumberId,
        staleTime: 5 * 60 * 1000,
        retry: false,
        refetchOnWindowFocus: false,
    });
};

export default useGetSpecialNumber;
